import styled from 'styled-components';

export const Container = styled.div`
	padding: 20px 20px 0 20px;
	width: 100%;
`;

export const ButtonContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 30px;
	justify-content: center;
	align-items: center;

	padding-top: 25px;

	svg {
		padding-left: 10px;
	}
`;

export const RadioContainer = styled.div`
	display: flex;
	align-items: center;

	padding-top: 10px;
`;
